export default {

    
    abonents() {
        return new Promise((resolve, reject) => {

            setTimeout(()=> {


                resolve([

                    { 
                        account: "100300614",
                        canWire: true,
                        defaultWired: false,
                        error: "",
                        fio: "Иванов И.И.",
                        id: "65b12df5-bc24-48b0-af0f-723ede9a0eba",
                        name: "Электроэнергия",
                    },

                    { 
                        account: "100300615",
                        canWire: true,
                        defaultWired: false,
                        error: "",
                        fio: "Иванов И.И.",
                        id: "65b12df5-bc24-48b0-af0f-723ede9a0ebb",
                        name: "Газоснабжение",
                    },

                    { 
                        account: "100300616",
                        canWire: true,
                        defaultWired: false,
                        error: "",
                        fio: "Иванов И.И.",
                        id: "65b12df5-bc24-48b0-af0f-723ede9a0ebc",
                        name: "Горячее водоснабжение",
                    },

                    { 
                        account: "100300617",
                        canWire: true,
                        defaultWired: false,
                        error: "",
                        fio: "Иванов И.И.",
                        id: "65b12df5-bc24-48b0-af0f-723ede9a0ebd",
                        name: "Холодное водоснабжение",
                    }

                ])



            }, 1000)

        })
    },

    abonentsCancellable() {



        return {
            promise: this.abonents(),
            cancel: () => {
                console.log('abonents canceled!')
            }
        }
    },


    
    autocompleteCancellable(searchText) {

        let promise = new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve(
                  
                
                
                {
                    options:  [


                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '1'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '2'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '3', len: 6},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '4'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '5'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '6', len: 6},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '7'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '8'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '9', len: 6},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '10'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '11'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '12', len: 6},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '13'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '14'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '15', len: 6},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '16'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '17'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '18', len: 6},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '19'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '20'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '21', len: 6},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '22'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '23'},
                        { city: 'Барнаул', street: 'ул.Титова', building: '1', apartment: '24', len: 6}
                      /*   {} */
        
                      ]
                }
                
                
               );
            }, 1000);
        });
        
        return {
          promise,
          cancel: () => {
            console.log('autocomplete canceled!')
          }
        }



       
    }
}